export const MediaTypeEnum = {
    POSTER: 'POSTER',
    VIDEO: 'VIDEO',
    PDF: 'PDF'
};